module.exports = __webpack_public_path__ + "img/routes.2ba7da4b.png";